const AppStoreLogo = ({
	className = "",
	color = "#212B37",
	width = 14,
	height = 16,
	size = 14,
}) => (
	<svg
		className={className}
		width={size || width}
		height={size + 2 || height}
		viewBox="0 0 14 16"
		fill={color}
		xmlns="http://www.w3.org/2000/svg">
		<path
			d="M13.085 5.455c-.093.072-1.728.995-1.728 3.048 0 2.375 2.08 3.215 2.143 3.236-.01.051-.33 1.15-1.097 2.27-.684.986-1.397 1.97-2.483 1.97s-1.365-.632-2.619-.632c-1.222 0-1.656.653-2.65.653-.992 0-1.685-.912-2.482-2.032C1.246 12.652.5 10.609.5 8.67c0-3.111 2.018-4.76 4.005-4.76 1.055 0 1.935.694 2.598.694.63 0 1.614-.736 2.815-.736.455 0 2.09.041 3.167 1.587ZM9.348 2.551c.497-.59.848-1.41.848-2.23 0-.113-.01-.228-.03-.321-.808.03-1.77.54-2.35 1.213-.454.518-.88 1.338-.88 2.168 0 .125.022.25.031.29.051.01.134.02.217.02.725 0 1.637-.486 2.164-1.14Z"
			fill={color}
		/>
	</svg>
);
export default AppStoreLogo;
